var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24414 13.0811L3.1875 10.2783H6.66016L7.60352 13.0811H8.86133L5.53906 3.75H4.32227L1 13.0811H2.24414ZM4.94434 5.1582L6.33887 9.31445H3.50879L4.91016 5.1582H4.94434Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0908 12.1855H14.125V13.0811H15.2529V8.125C15.2529 6.61426 14.1387 5.78027 12.6074 5.78027C10.8711 5.78027 10.0166 6.69629 9.94141 7.9541H11.0488C11.1172 7.23633 11.6436 6.76465 12.5664 6.76465C13.5371 6.76465 14.084 7.28418 14.084 8.22754V8.95898H12.1904C10.543 8.96582 9.66797 9.75879 9.66797 11.0166C9.66797 12.3359 10.625 13.1973 12.0127 13.1973C13.0723 13.1973 13.7285 12.7666 14.0908 12.1855ZM12.3271 12.2197C11.5752 12.2197 10.8711 11.8232 10.8711 10.9756C10.8711 10.3262 11.2949 9.86133 12.2793 9.86133H14.084V10.6953C14.084 11.5908 13.332 12.2197 12.3271 12.2197Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingButton);
export default __webpack_public_path__ + "static/media/headingButton.26c76fcd99fa2c7ab5be23945aeee028.svg";
export { ForwardRef as ReactComponent };